export type ExportScope = "all" | "selection" | "adverse";

type Selection = {
  scope: ExportScope;
  kinds: string[];
  participantIds: string[];
  formIds: string[];
};

// Body sent to the API; null means the whole study, as before.
export const buildExportFilters = ({
  scope,
  kinds,
  participantIds,
  formIds,
}: Selection) => {
  if (scope === "all") return null;
  if (scope === "adverse") {
    return { include: ["events"], eventTypes: ["ADVERSE"], participantIds };
  }
  return { include: kinds, participantIds, formIds };
};

export const exportFormat = (scope: ExportScope, chosen: string) =>
  scope === "adverse" ? "PDF" : chosen;
